import styled from 'styled-components';

const HorizontalRuler = styled.div<{color?: string}>`
  border-bottom: 1px solid ${({ theme, color }) => color ? theme.colors[color] : theme.colors.navy};
`;

export default HorizontalRuler;